// extracted by mini-css-extract-plugin
export default {"fas-icon":"fas-icon--529326","fasIcon":"fas-icon--529326"};